import { createSlice } from '@reduxjs/toolkit'

export const productSlice = createSlice({
  name: 'productSlice',
  initialState: {
    value: 'none'
  },
  reducers: {
    getSelectedProduct: (state, action) => {
      return action.payload
    }
  }
})

export const { getSelectedProduct } = productSlice.actions
export default productSlice.reducer
